module.exports = __webpack_public_path__ + "static/media/jawRight.d50ddbc9.obj";